// extracted by mini-css-extract-plugin
module.exports = {"your-feed__list":"your-feed_your-feed__list___hnjc","your-feed__carousel":"your-feed_your-feed__carousel__PCQ4_","your-feed__empty-state":"your-feed_your-feed__empty-state__fZJil"};